import { AnalyticsEvent } from '@att-bit/ui-frameworks.components.analytics-event';
import { docComplete } from './docComplete';
import { AnalyticsEventProps } from './analytics-event';
declare global {
    interface Window {
        Invoca:any;
    }
  }
export class AnalyticsQueue {
    static instance:any = null;
    static getInstance() {
        if (!AnalyticsQueue.instance) AnalyticsQueue.instance = new AnalyticsQueue();
        return AnalyticsQueue.instance;
    };

    private impressionArray:any;
    private pageLoadComplete:boolean;

    constructor() {
        this.impressionArray = [];
        this.pageLoadComplete = false;
    }

    setImpression(data:AnalyticsEventProps) {
        if (this.pageLoadComplete) {
            AnalyticsEvent(data);
            if (window) window["Invoca"] && window["Invoca"].PNAPI.run();
        } else {
            this.impressionArray.push(data);
        }
    }

    sendPageLoad(pageLoadData:any) {
        this.sendEvent();
    }

    private sendEvent() {
        docComplete(()=>{
            const tempArray = [...this.impressionArray];
            this.impressionArray = [];
            this.pageLoadComplete = true;
            tempArray.forEach((item) => {
                AnalyticsEvent(item);
            });
        }); 
    }
} 

export default AnalyticsQueue.getInstance();